import { createBasicLocation, ILocation } from "src/router/routeTypes"

const TASK_MANAGEMENT_PATH = "/task-management"
const TASK_MANAGEMENT_BETA_SIGNUP_PATH = TASK_MANAGEMENT_PATH + "/beta/signup"
const TASK_MANAGEMENT_BETA_PATH = TASK_MANAGEMENT_PATH + "/beta"

const TaskManagement = createBasicLocation(TASK_MANAGEMENT_PATH)

const ListView: ILocation<void> = {
  location() {
    return {
      pathname: `${TaskManagement.location().pathname}`,
      hash: "list",
    }
  },
}

const TodoTasks: ILocation<void> = {
  location() {
    return {
      pathname: `${TaskManagement.location().pathname}`,
      hash: "todo",
    }
  },
}

const CompletedTasks: ILocation<void> = {
  location() {
    return {
      pathname: `${TaskManagement.location().pathname}`,
      hash: "completed",
    }
  },
}

const CalendarTasks: ILocation<void> = {
  location() {
    return {
      pathname: `${TaskManagement.location().pathname}`,
      hash: "calendar",
    }
  },
}

const TaskTemplates: ILocation<void> = {
  location() {
    return {
      pathname: `${TaskManagement.location().pathname}`,
      hash: "templates",
    }
  },
}

const TaskAutomations: ILocation<void> = {
  location() {
    return {
      pathname: `${TaskManagement.location().pathname}`,
      hash: "automations",
    }
  },
}

const Task: ILocation<string> = {
  location(taskId) {
    const pathname = `${TaskManagement.location().pathname}/task/${taskId}`
    return { pathname }
  },
}

const TaskManagementBetaSignup = createBasicLocation(
  TASK_MANAGEMENT_BETA_SIGNUP_PATH
)

const TaskManagementBetaStart = createBasicLocation(TASK_MANAGEMENT_BETA_PATH)

export const TaskManagementRoutes = {
  TaskManagementBetaSignup,
  TaskManagementBetaStart,
  TaskManagement,
  ListView,
  TodoTasks,
  CompletedTasks,
  CalendarTasks,
  TaskTemplates,
  TaskAutomations,
  Task,
} as const
